<template>
  <div>
    <el-table
        ref="multipleTable"
        :data="tableData">
      <el-table-column prop="billNO" align="center" label="PC"/>
      <el-table-column prop="techParamBillNO" align="center" label="合同号"/>
      <el-table-column prop="cabinetType" align="center" label="变频器功率"/>
      <el-table-column prop="createTime" align="center" label="扫描时间"/>
      <el-table-column prop="checkPoints" align="center" label="点位"/>
      <el-table-column prop="result" align="center" label="结果"/>
      <el-table-column align="center" label="图片">
        <template slot-scope="scope">
          <img width="100%" :src="getFullPath(scope.row.filePath)" alt="">
        </template>
      </el-table-column>
      <el-table-column prop="note" align="center" label="备注"/>
    </el-table>
  </div>
</template>

<script>

  export default {
    name: "ControlBoxInspectionDetail",
    components: {},
    data() {
      return {
        pkid:"",
        tableData: [],
      };
    },
    mounted() {
      this.pkid = this.$route.query.pkid;
      this.$nextTick(() => {
        this.getList();
      });

    },
    methods: {
      getList() {
        this.$http
          .get("basic",`controlBoxInspections/${this.pkid}`)
          .then((resp)=>{
            console.log(resp);
            this.tableData = resp;
          })
          .catch(() => {
          });
      },
      getFullPath(url) {
        return  window.config.basicServerHttpUrl + "file/download?uuid=" + url+"&name=" + "PIC.jpeg";
      },
    },
  };
</script>
<style scoped>
</style>
